module.exports = __webpack_public_path__ + "static/img/logo_portal_fundo_transparente.bd9a460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_portal_fundo_transparente.png
// module id = ke2D
// module chunks = 0